export default "__VITE_ASSET__Lc4vhScO__"